// This file combines PixelFilter and PixelCalc tools
// Merged into one component for accessing all operations

import React, { useState, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { HOST } from "../../host";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import { bbox, area } from "@turf/turf";
import { logToServer } from "../../logger";
import PixelFilter from "./PixelFilter";
import PixelCalc from "./RasCalc";

function PixelTool() {
    const {
        drawnItems,
        lastRect,
        selectedLayers,
        vis,
        setLBands,
        LayerBands,
        layerControls,
        map,
        userInfo,
        selTab,
        Canvas,
        getCsrfToken
    } = useContext(GlobalContext);

    const [show, setshow] = useState(false);
    const [showPixelFilter, setshowPixelFilter] = useState(false);
    const [showRasCalc, setshowRasCalc] = useState(false);
    const [FLayers, setFLayers] = useState([]);
    const [selLayer, SetlLayer] = useState("");
    const [bands, setBands] = useState([]);
    const [Query, setQuery] = useState("");
    const [showwait, setwait] = useState(false);
    const [keyDict, setDict] = useState({});
    const location = useLocation();
    const toolRef = useRef(null);

    return (
        <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">

            {/* ── Trigger Button ── */}
            <button
                className="btn text-white"
                title="Pixel Filter / Raster Calculator"
                onClick={() => setshow(!show)}
                style={{ backgroundColor: 'black', width: '40px', height: '40px', borderRadius: '50%', border: 'none' }}
            >
                <i className="fa-solid fa-calculator" />
            </button>

            {show && (
                <div ref={toolRef} className="toolsvis" style={{ display: "flex", flexDirection: "column", width: "220px", padding: "10px 12px" }}>

                    {/* ── Header ── */}
                    <div style={{
                        display: "flex", justifyContent: "space-between", alignItems: "center",
                        paddingBottom: "8px", marginBottom: "10px",
                        borderBottom: "1px solid rgba(255,255,255,0.12)"
                    }}>
                        <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
                            <i className="fa-solid fa-calculator" style={{ marginRight: "6px", fontSize: "11px" }} />
                            Pixel Filter / Raster Calculator
                        </span>
                        <span
                            onClick={() => setshow(false)}
                            style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
                        >
                            &times;
                        </span>
                    </div>

                    {/* ── Options ── */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <input
                                type="checkbox"
                                checked={showPixelFilter}
                                onChange={(e) => setshowPixelFilter(prev => !prev)}
                            />
                            <label style={{ color: "white", fontSize: "12px", margin: 0 }}>Pixel Filter</label>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <input
                                type="checkbox"
                                checked={showRasCalc}
                                onChange={(e) => setshowRasCalc(prev => !prev)}
                            />
                            <label style={{ color: "white", fontSize: "12px", margin: 0 }}>Raster Calculator</label>
                        </div>

                        {showPixelFilter && <PixelFilter />}
                        {showRasCalc && <PixelCalc />}

                        {showwait && (
                            <p style={{ color: "#ccc", fontSize: "12px", margin: "4px 0 0" }}>Please wait...</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default PixelTool;